var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyFundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 2.75C11.75 3.85457 9.28757 4.75 6.25 4.75C3.21243 4.75 0.75 3.85457 0.75 2.75M11.75 2.75C11.75 1.64543 9.28757 0.75 6.25 0.75C3.21243 0.75 0.75 1.64543 0.75 2.75M11.75 2.75V7.20715C10.5285 7.57398 9.75 8.12893 9.75 8.75M0.75 2.75V14.75C0.75 15.8546 3.21243 16.75 6.25 16.75C7.57963 16.75 8.79906 16.5784 9.75 16.2929V8.75M0.75 6.75C0.75 7.85457 3.21243 8.75 6.25 8.75C7.57963 8.75 8.79906 8.57843 9.75 8.29285M0.75 10.75C0.75 11.8546 3.21243 12.75 6.25 12.75C7.57963 12.75 8.79906 12.5784 9.75 12.2929M20.75 8.75C20.75 9.85457 18.2876 10.75 15.25 10.75C12.2124 10.75 9.75 9.85457 9.75 8.75M20.75 8.75C20.75 7.64543 18.2876 6.75 15.25 6.75C12.2124 6.75 9.75 7.64543 9.75 8.75M20.75 8.75V16.75C20.75 17.8546 18.2876 18.75 15.25 18.75C12.2124 18.75 9.75 17.8546 9.75 16.75V8.75M20.75 12.75C20.75 13.8546 18.2876 14.75 15.25 14.75C12.2124 14.75 9.75 13.8546 9.75 12.75",
    stroke: "#474747",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyFundIcon);
export default __webpack_public_path__ + "static/media/my_fund_icon.dcefceb2f02a8e65075496e7ab3c89ca.svg";
export { ForwardRef as ReactComponent };